module.exports = __webpack_public_path__ + "static/media/trainingIcon.9ab87e08.svg";